import { Component, OnInit } from '@angular/core';
import {Location} from "@angular/common";
@Component({
  selector: 'app-szitas12513',
  templateUrl: './szitas12513.component.html',
  styleUrls: ['./szitas12513.component.scss']
})
export class Szitas12513Component implements OnInit {

  constructor(private location: Location) {

  }
  ngOnInit() {
  }

  backToPrevPage() {
    this.location.back();
  }

}
